import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BaseAutomationModel, TriggeringActionType } from '../models/automation/automation.model';
import { FormService } from '../services/form.service';
import { FormType } from '../models/application/formType';
@Pipe({
  name: 'automationName',
  standalone: false
})
export class AutomationNamePipe implements PipeTransform {
  constructor(private formService: FormService) {}
  transform(
    automation: BaseAutomationModel,
    isTeamCredential: boolean = false
  ): Observable<string> {
    switch (automation.automationTrigger.triggeringActionType) {
      case TriggeringActionType.FormSubmitted:
        return this.formService.activeTemplates.pipe(
          map((forms) => {
            if (!forms) {
              let formType = isTeamCredential ? FormType.Team : FormType.Application;
              this.formService.getAllActiveTemplates(formType);
              return;
            }
            const formName = forms.find(
              (x) => x.id == automation.automationTrigger.entityId
            )?.title;
            if (formName) {
              return `${automation.triggeringActionTypeTitle}: ${formName}`;
            }
            return '';
          })
        );
      case TriggeringActionType.MaintenanceRule:
        return of(automation.triggeringActionTypeTitle);
      default:
        return of('');
    }
  }
}
